import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { withModel } from '../data-providers/model';

const getCountryContent = props => {
  const currentCountry = props.model.countryModel;
  const prismicCountries = props.model.prismicCountryListModel.countries;

  const country = prismicCountries
    .filter(prismicCountry => prismicCountry.iso === currentCountry.iso)
    .find((prismicCountry, index, array) => {
      let sameLocale = true;
      if (array.length > 1) {
        sameLocale = prismicCountry.localeCode && currentCountry.contentLocales.includes(
          prismicCountry.localeCode.toLowerCase(),
        );
      }
      return sameLocale;
    });

  return country || {};
};

const withCountry = compose(
  withModel,
  withProps(props => ({
    country: {
      ...props.model.countryModel,
      ...getCountryContent(props),
    },
  })),
);

export default withCountry;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withCountry.js